export default __webpack_public_path__ + "1907e0faae8d9f9d1f1f15e370790da1.svg";